import { createFileRoute } from "@tanstack/react-router";

import { CountrySpecialtiesClient } from "@/components/admin/specialties/country-specialties-client";

/**
 * Admin → Specialties → Countries (per-country specialty matrix subpage).
 *
 * V1.1 P1 — D21 STRICT 1:1 port of legacy
 * `src/app/admin/specialties/countries/country-specialties-client.tsx` (~663 LOC).
 * Standalone subpage with country selector + sortable table + inline edit + AI translate.
 *
 * TanStack Router flat-file convention: `specialties.countries.tsx` = `/specialties/countries`.
 */
export const Route = createFileRoute("/_authenticated/specialties/countries")({
  component: CountrySpecialtiesClient,
});
